// src/hooks/useProducts.ts

import { useState, useEffect } from 'react';
import { Product, ProductFilters, ProductsApiResponse } from '../types';
import { fetchProducts } from '../utils/api';

interface UseProductsReturn {
  products: Product[];
  total:    number;
  pages:    number;
  loading:  boolean;
  error:    string | null;
  refetch:  () => void;
}

export const useProducts = (filters: ProductFilters = {}): UseProductsReturn => {
  const [products, setProducts] = useState<Product[]>([]);
  const [total,    setTotal]    = useState<number>(0);
  const [pages,    setPages]    = useState<number>(1);
  const [loading,  setLoading]  = useState<boolean>(true);
  const [error,    setError]    = useState<string | null>(null);

  const filtersKey = JSON.stringify(filters);

  const load = async (): Promise<void> => {
    setLoading(true);
    setError(null);
    try {
      const data: ProductsApiResponse = await fetchProducts(filters);
      setProducts(data.products ?? []);
      setTotal(data.total ?? 0);
      setPages(data.pages ?? 1);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load products');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [filtersKey]); // re-fetches when any filter changes

  return { products, total, pages, loading, error, refetch: load };
};
